import React from 'react';
import { Plus, Search, Loader2, ChevronUp } from 'lucide-react';

const PrinterSearchModal = ({
  isOpen,
  onClose,
  onScan,
  scanning,
  foundPrinters,
  onConfigurePrinter,
  onTestPrinter,
  clientStatus
}) => {
  if (!isOpen) return null;
  
  const scanDisabled = scanning || clientStatus !== 'running';
  
  const getTooltip = () => {
    if (scanning) return 'Escaneando...';
    if (clientStatus !== 'running') return 'Cliente de impresión no conectado';
    return 'Buscar impresoras en la red';
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity z-50 ${
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
      />

      {/* Bottom Sheet */}
      <div
        className={`fixed inset-x-0 bottom-0 transform ${
          isOpen ? 'translate-y-0' : 'translate-y-full'
        } transition-transform duration-300 ease-in-out z-50`}
      >
        <div className="relative bg-white dark:bg-gray-800 rounded-t-xl shadow-lg max-w-4xl mx-auto">
          {/* Header con botón de cierre */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              Agregar Nueva Impresora
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full"
            >
              <ChevronUp className="w-5 h-5 text-gray-500" />
            </button>
          </div>

          <div className="p-6 space-y-6">
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Puedes buscar impresoras en tu red local o agregar una manualmente
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <button
                onClick={onScan}
                disabled={scanDisabled}
                title={getTooltip()}
                className={`flex items-center justify-center gap-2 px-4 py-3 rounded-lg transition-colors ${
                  scanDisabled
                    ? 'bg-gray-100 dark:bg-gray-700 text-gray-500 cursor-not-allowed'
                    : 'bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300'
                }`}
              >
                {scanning ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    <span>Buscando impresoras...</span>
                  </>
                ) : (
                  <>
                    <Search className="w-4 h-4" />
                    <span>Buscar en la Red</span>
                  </>
                )}
              </button>

              <button
                onClick={() => {
                  onConfigurePrinter(null);
                  onClose();
                }}
                className="flex items-center justify-center gap-2 px-4 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                <Plus className="w-4 h-4" />
                <span>Configurar Manualmente</span>
              </button>
            </div>

            {/* Resultados del escaneo */}
            {scanning && (
              <div className="py-8 flex justify-center">
                <div className="flex items-center gap-3 text-gray-500 dark:text-gray-400">
                  <Loader2 className="w-5 h-5 animate-spin" />
                  <span>Buscando impresoras en la red...</span>
                </div>
              </div>
            )}

            {!scanning && foundPrinters?.length > 0 && (
              <div className="border rounded-lg divide-y divide-gray-200 dark:divide-gray-700">
                {foundPrinters.map((printer, index) => (
                  <div 
                    key={printer.ip_address}
                    className="flex items-center justify-between p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50"
                  >
                    <div>
                      <h3 className="font-medium text-gray-900 dark:text-white">
                        Impresora {index + 1}
                      </h3>
                      <p className="text-sm text-gray-500 dark:text-gray-400">
                        IP: {printer.ip_address}
                      </p>
                    </div>
                    <button
                      onClick={() => {
                        onConfigurePrinter(printer);
                        onClose();
                      }}
                      className="flex items-center gap-2 px-3 py-1.5 text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:hover:bg-blue-900/30 rounded-lg"
                    >
                      <Plus className="w-4 h-4" />
                      <span>Configurar</span>
                    </button>
                  </div>
                ))}
              </div>
            )}

            {!scanning && foundPrinters?.length === 0 && (
              <div className="py-8 text-center text-gray-500 dark:text-gray-400">
                No se encontraron impresoras en la red
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PrinterSearchModal; 